module.exports = __webpack_public_path__ + "static/insta5-c005d590061222dafa4a8a64b33c6c97.png";